import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ys_admin_token");
    if (token && config.url && config.url.includes("/admin/")) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function absoluteUploadUrl(path) {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${BACKEND_URL}${path}`;
}
